import { useCallback, useEffect, useState } from 'react';
import { AppNoInfo } from '@/layout/AppComponents';
import styled from 'styled-components';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import { axiosPath } from '../../../../../../routing/helpers/router';
import Translator from '../../../../../components/helpers/Translator';
import useIsMounted from '../../../../../components/hooks/useIsMounted';
import errorHandler from '../../../../../components/error/ErrorHandler';

export default function AspectsTab({ inspectionID }) {
  const { moduleBridgeHex, plantHex, assessmentHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [aspects, setAspects] = useState();

  // > LOAD ASPECTS
  const loadAspects = useCallback(
    async () =>
      axios
        .post(
            axiosPath(
              'api_r_user_module_environmentalAspectsAssessment_inspection_evaluation_aspect_list'
            ),
          {
            moduleBridgeHex,
            assessmentHex,
            plantHex,
            inspectionID,
          }
        )
        .then(({ data }) => {
          if (isMounted.current) {
            setAspects(data);
          }
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex, plantHex, plantHex, inspectionID]
  );

  useEffect(() => {
    loadAspects();
  }, []);
  // < LOAD ASPECTS

  const renderEvaluationText = useCallback((aspect) => {
    if (aspect?.apply) {
      if (aspect?.evaluation !== null) {
        return aspect?.evaluation === 1 ? 'Significativo' : 'No significativo';
      }

      return 'No evaluado';
    }

    return 'No aplica';
  }, []);

  const renderEvaluationColor = useCallback((aspect) => {
    if (aspect?.apply) {
      if (aspect?.evaluation !== null) {
        return aspect?.evaluation === 1 ? 'text-danger' : 'text-warning';
      }

      return 'text-info';
    }

    return 'text-success';
  }, []);

  if (!aspects) return <AppNoInfo minHeight={400} />;

  return (
    <Container className="pt-3 border-top-0 bg-white">
      <div className="table-responsive">
        <table className="table table-hover sm-table">
          <thead>
            <tr>
              <td>
                <b>Aspecto</b>
              </td>
              <td>
                <b>Descripción</b>
              </td>
              <td>
                <b>Evaluación</b>
              </td>
            </tr>
          </thead>
          <tbody>
            {aspects?.map((a) => (
              <tr key={a?.hex}>
                <td>{a?.aspect}</td>
                <td>{a?.description}</td>
                <td>
                  <b className={renderEvaluationColor(a)}>
                    {renderEvaluationText(a)}
                  </b>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Container>
  );
}

const Container = styled.div`
  height: 420px;
  overflow: auto;
`;
